import _ from 'lodash'

import {
    LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
    DATA_TABLE_REQUEST,
    REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
    OPEN_CADASTRE_LINK,
    OPEN_CADASTRE_LINK_REQUEST,
} from './constants'

import config from '../../../../../../../../../../../../../config'

export function loadDataTable(id, listId, page, rowsPerPage, sorting) {
    return {
        type: LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
        data: {
            id,
            listId,
            page,
            rowsPerPage,
            sorting,
        },
    }
}

export function loadDataTableRequest(module, id, blockKey, listId, qs) {
    const tableConfig = _.get(config, `api.${module}.${blockKey}.extended.listDetail`, {})

    return {
        type: DATA_TABLE_REQUEST(module, id, blockKey, listId),
        payload: {
            ...tableConfig,
            uriParams: {
                [config.modules[module].blockIdKey]: id,
                listId,
            },
            qs,
        },
    }
}

export function removeDataTable(id, listId) {
    return {
        type: REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
        data: {
            id,
            listId,
        },
    }
}

export function openCadastreLink() {
    return {
        type: OPEN_CADASTRE_LINK,
    }
}

export function openCadastreLinkRequest() {
    return {
        type: OPEN_CADASTRE_LINK_REQUEST,
        payload: {
            ...config.api.realEstatesCadastreLink,
        },
    }
}
